export enum TaskCalendarViewType {
  WEEK = 'WEEK',
  DAY = 'DAY',
  MONTH = 'MONTH'
}
